import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setError('Invalid or missing reset token');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    
    if (!password || !confirmPassword) {
      setError('Please fill in all fields');
      return;
    }
    
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    
    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: token,
          new_password: password,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
        setMessage('✅ Password has been reset successfully! Redirecting to login...');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        setError(data.detail || 'Failed to reset password. Please try again.');
      }
    } catch (error) {
      console.error('Reset password error:', error);
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-form">
        <div className="phoenix-logo" style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img 
            src="/logo.webp" 
            alt="Zero Give Up" 
            style={{ maxWidth: '200px', height: 'auto' }}
          />
        </div>
        <h2>Invalid Reset Link</h2>
        <div className="error-message">
          The password reset link is invalid or has expired.
        </div>
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <Link to="/login" className="link">← Back to Login</Link>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="auth-form">
        <div className="phoenix-logo" style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img 
            src="/logo.webp" 
            alt="Zero Give Up" 
            style={{ maxWidth: '200px', height: 'auto' }}
          />
        </div>
        <h2>Password Reset Successful!</h2>
        <div className="success-message">
          {message}
        </div>
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <Link to="/login" className="link">Go to Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-form">
      <div className="phoenix-logo" style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <img 
          src="/logo.webp" 
          alt="Zero Give Up" 
          style={{ maxWidth: '200px', height: 'auto' }}
        />
      </div>
      
      <h2>Reset Your Password</h2>
      <p style={{ textAlign: 'center', marginBottom: '2rem', color: 'var(--text-light)' }}>
        Enter your new password below.
      </p>

      {error && <div className="error-message">{error}</div>}
      {message && <div className="success-message">{message}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="password">New Password</label>
          <input
            type="password"
            id="password"
            className="form-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength="6"
            placeholder="Enter new password"
          />
        </div>

        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm New Password</label>
          <input
            type="password"
            id="confirmPassword"
            className="form-input"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            minLength="6"
            placeholder="Confirm new password"
          />
        </div>

        <button 
          type="submit" 
          className="btn btn-primary"
          disabled={loading}
          style={{ width: '100%' }}
        >
          {loading ? 'Resetting Password...' : 'Reset Password'}
        </button>
      </form>

      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <Link to="/login" className="link">← Back to Login</Link>
      </div>
    </div>
  );
};

export default ResetPassword;